import { ActionType, FiltersData } from '../../types';

export const ManageAlarmsActions = {
    SetAlarmFilters: (filtersData: FiltersData) =>
        ({
            type: 'ManageAlarms/SetAlarmFilters',
            payload: {
                filtersData,
            },
        } as const),

    SetSelectedDeviceId: (deviceId: string) =>
        ({
            type: 'ManageAlarms/SetSelectedDeviceId',
            payload: {
                deviceId,
            },
        } as const),
    AlarmFiltersSaveStarted: () =>
        ({
            type: 'AlarmsFilters/Save/Started',
        } as const),

    AlarmFiltersSaveSucceeded: (message: string, data: {}) =>
        ({
            type: 'AlarmsFilters/Save/Succeeded',
            payload: { message, data },
        } as const),

    AlarmFiltersSaveFailed: (errorCode: string) =>
        ({
            type: 'AlarmsFilters/Save/Failed',
            payload: { errorCode },
        } as const),

    AlarmFiltersSaveUnmounted: () =>
        ({
            type: 'AlarmsFilters/Save/Unmounted',
        } as const),

    AlarmFiltersUpdateStarted: () =>
        ({
            type: 'AlarmsFilters/Update/Started',
        } as const),

    AlarmFiltersUpdateSucceeded: (message: string, data: {}) =>
        ({
            type: 'AlarmsFilters/Update/Succeeded',
            payload: { message, data },
        } as const),

    AlarmFiltersUpdateFailed: (errorCode: string) =>
        ({
            type: 'AlarmsFilters/Update/Failed',
            payload: { errorCode },
        } as const),

    AlarmFiltersUpdateUnmounted: () =>
        ({
            type: 'AlarmsFilters/Update/Unmounted',
        } as const),

    DeviceChannelCountSucceeded: (message: string, data: {}) =>
        ({
            type: 'DeviceChannel/Count/Succeeded',
            payload: { message, data },
        } as const),

    DeviceChannelCountStarted: () =>
        ({
            type: 'DeviceChannel/Count/Started',
        } as const),

    DeviceChannelCountFailed: (errorCode: string) =>
        ({
            type: 'DeviceChannel/Count/Failed',
            payload: { errorCode },
        } as const),
    DeviceChannelCountUnmounted: () =>
        ({
            type: 'DeviceChannel/Count/Unmounted',
        } as const),

    AlarmConfigSaveStarted: () =>
        ({
            type: 'AlarmsConfig/Save/Started',
        } as const),

    AlarmConfigSaveSucceeded: (message: string, data: {}) =>
        ({
            type: 'AlarmsConfig/Save/Succeeded',
            payload: { message, data },
        } as const),

    AlarmConfigSaveFailed: (errorCode: string) =>
        ({
            type: 'AlarmsConfig/Save/Failed',
            payload: { errorCode },
        } as const),

    AlarmConfigSaveUnmounted: () =>
        ({
            type: 'AlarmsConfig/Save/Unmounted',
        } as const),

    StarfishUpgradeStarted: () =>
        ({
            type: 'AlarmsConfig/Save/Started',
        } as const),

    StarfishUpgradeSucceeded: (message: string, data: {}) =>
        ({
            type: 'AlarmsConfig/Save/Succeeded',
            payload: { message, data },
        } as const),

    StarfishUpgradeFailed: (errorCode: string) =>
        ({
            type: 'AlarmsConfig/Save/Failed',
            payload: { errorCode },
        } as const),

    StarfishUpgradeUnmounted: () =>
        ({
            type: 'AlarmsConfig/Save/Unmounted',
        } as const),
};

export type ManageAlarmsActions = ActionType<typeof ManageAlarmsActions>;
